module.exports = __webpack_public_path__ + "img/bild4.a5cc54b6.jpeg";